import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService {
  public prependLS = 'luminous_';
  constructor() {}

  get(id :string) {
    try {
      return JSON.parse(localStorage.getItem(this.prependLS + id));
    } catch (e) {}
  }

  save(id :string, value :any) :void {
    localStorage.setItem(this.prependLS + id, JSON.stringify(value));
  }
}
